import type { ComponentType, FC } from "react";
import Box from "@mui/material/Box";
import { ChevronRightIcon, type IconProps } from "../shared/icons";
import { useLocation } from "react-router";
import { Link } from "../dynamicShared/Link";
import { withQueryParams } from "../shared/navigateWithQueryParams";

type OpenSubDrawerLinkProps = {
  to: string;
  label?: number | string;
  Icon: ComponentType<IconProps>;
};

export const OpenSubDrawerLink: FC<OpenSubDrawerLinkProps> = ({ to, label, Icon }) => {
  const { search } = useLocation();

  return (
    <Box sx={{ position: "relative" }}>
      <Link
        sx={{
          "display": "inline-flex",
          "alignItems": "center",
          /** Increase the clickable area */ "&:before": {
            content: "''",
            position: "absolute",
            inset: 0,
            transform: "scale(5,2)",
          },
        }}
        Icon={Icon}
        to={withQueryParams(to, search)}
      >
        {label && (
          <Box component="span" sx={{ mr: 1 }}>
            {label}
          </Box>
        )}
        <ChevronRightIcon size={12} />
      </Link>
    </Box>
  );
};
